import { DateISO } from 'api/interfaces';
import { get } from 'api/methods';
import { AxiosError } from 'axios';
import { IAxiosRetryConfig } from 'axios-retry';
import {
  IAssembleiaAssociadoEvento,
  IEventosPorAssociado,
} from 'store/modules/AssembleiasAssociadoReducer';

// interface Conta {
//   codigoAgencia: string;
//   codigoCooperativa: string;
//   cpfCnpj: string;
//   cpfRepresentanteConfirmado: string;
//   cpfRepresentanteLegal: string;
//   idAssociado: number;
//   idConvocado: number;
//   nomeAssociado: string;
//   numeroConta: string;
//   numeroNucleo: string;
//   presente: boolean;
//   tipoPresenca: number;
// }

// type Contas = Conta[];

interface ComissaoEleitoralMembro {
  nomeAssociado: string;
}

type ComissaoEleitoral = Array<ComissaoEleitoralMembro>;

interface EventoResponse {
  dataEvento: DateISO;
  idEvento: number;
  nomeCoop: string;
  situacaoOnlineEvento: number;
  tipoEvento: string;
  tituloEvento: string;
}

export type ProximosEventosResponse = Array<EventoResponse>;

const retryDocumentsConfig: IAxiosRetryConfig = {
  retries: 2,
  retryCondition: (error: AxiosError) => {
    const status = Number(error.response?.status);
    // Condição para retry baseada em erros 5xx
    return status >= 500 || status === 408;
  },
};

const evento = {
  carregar: (idEvento: number) => {
    return get<IAssembleiaAssociadoEvento>(
      'eventoAssociado',
      `evento/${idEvento}`
    );
  },
  loadGuest: (idEvento: number) => {
    return get<IAssembleiaAssociadoEvento>(
      'eventoAssociado',
      `evento/${idEvento}/convidado`
    );
  },
  listarEventosAssociado: () => {
    return get<IEventosPorAssociado[]>('eventoAssociado', 'evento/pos-logado');
  },
  listarComissaoEleitoral: (idEvento: number) => {
    return get<ComissaoEleitoral>(
      'eventoAssociado',
      `evento/comissao-eleitoral/${idEvento}`
    );
  },
  listarProximos: () => {
    return get<ProximosEventosResponse>('eventoAssociado', 'evento/proximos');
  },
  downloadDemostrativo: (idEvento: number) => {
    return get<ArrayBuffer>(
      'coopsExterno',
      `documentos/download-demonstrativo/${idEvento}`,
      {
        responseType: 'arraybuffer',
        'axios-retry': retryDocumentsConfig,
      }
    );
  },

  downloadVoucher: (idEvento: number, contaCorrentes: Array<string>) => {
    return get<ArrayBuffer>(
      'coopsExterno',
      `documentos/download-voucher/${idEvento}`,
      {
        responseType: 'arraybuffer',
        params: { contaCorrentes },
        paramsSerializer: {
          indexes: null,
        },
        'axios-retry': retryDocumentsConfig,
      }
    );
  },
};

export default evento;
